import { useEffect, useState } from "react";

/**
 * The value, a beat after it stopped changing.
 *
 * Every list screen here mints a new query key on each keystroke, so typing six characters fires
 * six requests and the last one does all the work. That is wasteful, but the visible problem is
 * worse: the responses can land out of order, so the rows flicker between two different answers
 * before settling on the one you asked for.
 *
 * 200ms is chosen to sit under the ~250ms at which a pause starts to feel like lag, while still
 * covering the gap between keystrokes at an ordinary typing speed.
 */
export function useDebounced<T>(value: T, ms = 200): T {
  const [settled, setSettled] = useState(value);
  useEffect(() => {
    const t = window.setTimeout(() => setSettled(value), ms);
    return () => window.clearTimeout(t);
  }, [value, ms]);
  return settled;
}
